import { Pipe, PipeTransform } from '@angular/core';
import { List, initial } from 'lodash';

@Pipe({
  name: 'initial',
  standalone: true,
})
export class InitialPipe implements PipeTransform {
  transform<T>(value: List<T> | null | undefined): T[] {
    return initial(value);
  }
}
